import { FC } from "react";

type ColorCircleProps = {
	value: string;
};

const ColorCircleRenderer: FC<ColorCircleProps> = ({ value }) => {
	return (
		<div
			style={{
				width: "20px",
				height: "20px",
				borderRadius: "50%",
				display: "inline-block",
				backgroundColor: value.toLowerCase(),
			}}
		/>
	);
};

export default ColorCircleRenderer;
